import React from 'react';
import { Row, Col, Select } from 'antd';

const FieldWidthSelector = ({
  value,
  onChange,
  style = {},
}) => {
  const widthOptions = [
    { value: '100', label: 'Full Width (100%)' },
    { value: '50', label: 'Half Width (50%)' },
  ];

  return (
    <>
      <Row className="form-required-field" style={{ marginTop: 15, ...style }}>
        Field Width:
      </Row>
      <Row style={{ marginTop: 5 }}>
        <Col>
          <Select
            style={{ width: 350 }}
            placeholder="Select Field Width"
            value={value || '100'}
            onChange={onChange}
            options={widthOptions}
          />
        </Col>
      </Row>
    </>
  );
};

export default FieldWidthSelector;
